export default __webpack_public_path__ + "static/SectionTwo_01_04-6ff2e2097e6df6893f101fead52a699f.webp";